import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import ApiSupplier from "../../../core/api/api.supplier";
import ApiBasketItemPerson from "../../../core/api/api.basketItemPerson";
import SwalMessage from "../_Components/SwalMessage";
import { Row, Col, Button, Card, Modal, Accordion, Spinner } from "react-bootstrap";
import { ClockHistory } from "react-bootstrap-icons";
import { FormControlLabel, TextField, Checkbox, IconButton } from "@mui/material";
import ShamsiDatePicker from "../_Components/ShamsiDatePicker";
import { PatternFormat } from "react-number-format";
import { useEffect } from "react";
import _ from "lodash";
import { tools } from "../../../core/utils/tools";
import HistoryOfItemForDesktop from "../Orders/components/HistoryOfItemForDesktop";
import HistoryOfTransactionsMobile from "../Orders/components/BasketItems/operatorUpdatePersonItemsCanceled/HistoryOfTransactionsMobile";
import Swal from "sweetalert2";
import { DateObject } from "react-multi-date-picker";
import { persian, customLocale } from "../_Components/customLocale";
import CloseIcon from "@mui/icons-material/CloseRounded";
import LogoutIcon from "@mui/icons-material/Logout";
import Delete from "@mui/icons-material/Delete";
import SelectComponent from "../_Components/ReactSelectComponent";
import HTMLInput from "../_Components/HTMLInput";

//پرداخت/دریافت تامین کننده بصورت گروهی - ویرایش گروهی -حذف گروهی
function ModalGaranti({ typeOfModalWaranty, selectedItem, basketId, setShowModalGaranty }) {
  const {
    handleSubmit,
    setValue,
    control,
    formState: { errors, isSubmitting },
  } = useForm();
  const [inputList, setInputList] = useState([]);
  let showPrice = new Intl.NumberFormat("en-US");
  const [ordersServiceGetItem, setOrderServiceGetItem] = useState();
  const [submitAndExit, setsubmitAndExit] = useState(false);
  const [isDeleteButton, setIsDeleteButton] = useState(false);
  const [supplier, setSupplier] = useState([]);
  const [supplierSelectedId, setSupplierSelectedId] = useState();
  const [checked, setChecked] = React.useState(false);
  const supplierOnchange = (event) => {
    setSupplierSelectedId(event);
  };

  useEffect(() => {
    (async () => {
      try {
        const allSupplier = await ApiSupplier.getAllSuppliersName();
        setSupplier(allSupplier);
        // -----------
        await fetchModalItemsContent();
      } catch (error) {
      }
    })();
  }, []);

  const handleClose = () => {
    setShowModalGaranty(false);
  };
  const onSubmit = async (data) => {
    if (_.isUndefined(data.supplierSelectedId) || _.isEmpty(data.supplierSelectedId)) {
      SwalMessage({
        title: "لطفا تامین کننده را انتخاب نمایید",
        iSsuccess: false,
        timer: 4000,
      });
      return;
    }
    let supplierSelectedId = data?.supplierSelectedId?.value;
    let basketItemPersons = [];
    for (const [key, value] of Object.entries(data)) {
      if (key.includes("price_")) {
        if (value != undefined) {
          let id = key.replace("price_", "");
          const selectedBasketId = ordersServiceGetItem.data.map(
            (item) => item.basketItemPersonList.find((person) => person.id == id)?.basketId,
          );
          basketItemPersons.push({
            basketItemPersonId: +id,
            basketId: Array.isArray(selectedBasketId)
              ? +selectedBasketId.find((basketId) => basketId !== undefined)
              : selectedBasketId, // making [123] to this => 123
            amount: parseFloat(value.replaceAll(",", "")),
            date: data["date_" + id],
            time: data["time_" + id],
            description: data["description_" + id],
            transactionId: data["itemTransaction_" + id],
          });
        }
      }

      if (key.includes("date_")) {
        if (value !== null && typeof value === "object") {
          data[key] = tools.DateFormat(value);
        }
      }
    }

    let jsonData = {
      supplierId: supplierSelectedId,
      basketItemPersons: basketItemPersons,
      verifyPayToWaranty: 0,
    };

    try {
      if (isDeleteButton) {
        jsonData.warrantyPaymentType = typeOfModalWaranty == "editPayToWarranty" ? 1 : 2;
        Swal.fire({
          title: `عملیات حذف آیتم های انتخاب شده`,
          text: `پرداخت/دریافت تامین کننده آیتم های انتخاب شده حذف خواهد شد، اطمینان دارید؟`,
          icon: "question",
          showDenyButton: true,
          confirmButtonText: "بله",
          denyButtonText: "خیر",
          customClass: {
            actions: "my-actions",
            cancelButton: "order-1 right-gap btn btn-secondary",
            confirmButton: "order-2 btn btn-success px-5",
            denyButton: "order-3 btn btn-danger px-5",
          },
          focusCancel: true
        }).then(async (result) => {
          if (result.isConfirmed) {
            const response = await ApiBasketItemPerson.DeletePayOrReceiveWarranty(jsonData);
            if (response.succeeded) {
              SwalMessage({
                title: "با موفقیت حذف شد.",
                iSsuccess: true,
              });
              handleClose();
              document.getElementById("submitButton").click();
            } else
              SwalMessage({
                title: response.message,
                iSsuccess: false,
                timer: 4000,
              });
          }
        });
      } else if (typeOfModalWaranty == "payToWarranty") {
        const PayToWaranty = await ApiBasketItemPerson.PayToWaranty(jsonData);
        if (PayToWaranty.data == -1) {
          Swal.fire({
            title: "عملیات پرداخت مجدد به تامین کننده",
            text: "برای حداقل یکی از آیتم های انتخابی پرداخت به تامین کننده دارد،آیا مجددا پرداخت به تامین کننده انجام شود؟",
            icon: "question",
            showDenyButton: true,
            confirmButtonText: "بله",
            denyButtonText: "خیر",
            customClass: {
              actions: "my-actions",
              cancelButton: "order-1 right-gap btn btn-secondary",
              confirmButton: "order-2 btn btn-success px-5",
              denyButton: "order-3 btn btn-danger px-5",
            },
            focusCancel: true
          }).then(async (result) => {
            if (result.isConfirmed) {
              jsonData.verifyPayToWaranty = 2;
              const response = await ApiBasketItemPerson.PayToWaranty(jsonData);
              if (response.succeeded) {
                if (submitAndExit) {
                  handleClose();
                }
                SwalMessage({
                  title: "تغییرات با موفقیت اعمال شد",
                  iSsuccess: true,
                });
                fetchModalItemsContent();
                document.getElementById("submitButton").click();
              } else
                SwalMessage({
                  title: PayToWaranty.message,
                  iSsuccess: false,
                  timer: 4000,
                });
            } else if (result.isDenied) {
              handleClose();
            }
          });
        } else if (PayToWaranty.succeeded) {
          if (submitAndExit) {
            handleClose();
          }
          SwalMessage({
            title: "تغییرات با موفقیت اعمال شد",
            iSsuccess: true,
          });
          fetchModalItemsContent();
          document.getElementById("submitButton").click();
        } else
          SwalMessage({
            title: PayToWaranty.message,
            iSsuccess: false,
            timer: 4000,
          });
      } else if (typeOfModalWaranty == "receiveFromWaranty") {
        {
          const ReceiveFromWaranty = await ApiBasketItemPerson.ReceiveFromWarranty(jsonData);
          if (ReceiveFromWaranty.data == -1) {
            Swal.fire({
              title: "عملیات دریافت مجدد از تامین کننده",
              text: "برای حداقل یکی از آیتم های انتخابی دریافت از تامین کننده دارد،آیا مجددا دریافت از تامین کننده انجام شود؟",
              icon: "question",
              showDenyButton: true,
              confirmButtonText: "بله",
              denyButtonText: "خیر",
              customClass: {
                actions: "my-actions",
                cancelButton: "order-1 right-gap btn btn-secondary",
                confirmButton: "order-2 btn btn-success px-5",
                denyButton: "order-3 btn btn-danger px-5",
              },
              focusCancel: true
            }).then(async (result) => {
              if (result.isConfirmed) {
                jsonData.verifyReceiveFromWarranty = 2;
                const response = await ApiBasketItemPerson.ReceiveFromWarranty(jsonData);
                if (response.succeeded) {
                  if (submitAndExit) {
                    handleClose();
                  }
                  SwalMessage({
                    title: "تغییرات با موفقیت اعمال شد",
                    iSsuccess: true,
                  });
                  fetchModalItemsContent();
                  document.getElementById("submitButton").click();
                } else
                  SwalMessage({
                    title: ReceiveFromWaranty.message,
                    iSsuccess: false,
                    timer: 4000,
                  });
              } else if (result.isDenied) {
                handleClose();
              }
            });
          } else if (ReceiveFromWaranty.succeeded) {
            if (submitAndExit) {
              handleClose();
            }
            SwalMessage({
              title: "تغییرات با موفقیت اعمال شد",
              iSsuccess: true,
            });
            fetchModalItemsContent();
            document.getElementById("submitButton").click();
          } else
            SwalMessage({
              title: ReceiveFromWaranty.message,
              iSsuccess: false,
              timer: 4000,
            });
        }
      } else if (typeOfModalWaranty == "editPayToWarranty") {
        const ReceiveFromWaranty = await ApiBasketItemPerson.EditPayToWarranty(jsonData);
        if (ReceiveFromWaranty.succeeded) {
          if (submitAndExit) {
            handleClose();
          }
          SwalMessage({
            title: "تغییرات با موفقیت اعمال شد",
            iSsuccess: true,
          });
          await fetchModalItemsContent();
          document.getElementById("submitButton").click();
        } else
          SwalMessage({
            title: ReceiveFromWaranty.message,
            iSsuccess: false,
            timer: 4000,
          });
      } else if (typeOfModalWaranty == "editReceiveFromWarranty") {
        const ReceiveFromWaranty = await ApiBasketItemPerson.EditReceiveFromWarranty(jsonData);
        if (ReceiveFromWaranty.succeeded) {
          if (submitAndExit) {
            handleClose();
          }
          SwalMessage({
            title: "تغییرات با موفقیت اعمال شد",
            iSsuccess: true,
          });
          await fetchModalItemsContent();
          document.getElementById("submitButton").click();
        } else
          SwalMessage({
            title: ReceiveFromWaranty.message,
            iSsuccess: false,
            timer: 4000,
          });
      }
    } catch (error) {
    }
  };

  async function fetchModalItemsContent() {
    let selectedItemSTR = "";
    selectedItem.forEach((item) => {
      selectedItemSTR += "ListBasketItemPersonID=" + item + "&";
    });

    if (
      typeOfModalWaranty === "payToWarranty" ||
      typeOfModalWaranty === "receiveFromWaranty"
    ) {
      const ordersServiceGetItem = await ApiBasketItemPerson.GetItemForWaranty({
        basketItemPersonList: selectedItem,
      });

      setOrderServiceGetItem(ordersServiceGetItem);
      if (!_.isEmpty(ordersServiceGetItem.data)) {
        ordersServiceGetItem.data.map((item) => {
          item.basketItemPersonList.map((person) => {
            const { shamsiDate, time } = setDefaultDateAndTime();
            setValue("date_" + person.id, shamsiDate);
            setValue("time_" + person.id, time);

            //  اگر نوع سازنده سبد "نماینده" بود، مبلغ را خودکار ست کن
            if (person.basketCreatorType === 1) {
              setValue("price_" + person.id, String(person.supplierSettlementPrice));
              //const percentage = ((priceValue / person.originalPrice) * 100).toFixed(0);
              //setValue("percent_" + person.id, percentage);
            }
          });
        });
      }
    } else if (
      typeOfModalWaranty === "editPayToWarranty" ||
      typeOfModalWaranty === "editReceiveFromWarranty"
    ) {
      var warrantyPaymentType =
        typeOfModalWaranty === "editPayToWarranty" ? 1 : 2;

      const basketItemPersons = await ApiBasketItemPerson.GetItemForEditWarranty({
        basketItemPersonList: selectedItem,
        warrantyPaymentType: warrantyPaymentType,
      });
      setOrderServiceGetItem(basketItemPersons);

      if (!_.isEmpty(basketItemPersons.data)) {
        basketItemPersons.data.map((itemPerson) => {
          itemPerson.basketItemPersonList.map((item) => {
            if (item.transactions && item.transactions.length > 0) {
              const transaction = item.transactions.find(
                (t) =>
                  t.isDeleted === false &&
                  (typeOfModalWaranty === "editReceiveFromWarranty"
                    ? t.type === 4
                    : t.type === 3)
              );
              if (transaction) {
                const { shamsiDate, time } = setDefaultDateAndTime();
                setValue(
                  "date_" + item.id,
                  transaction.completionDate ? transaction.completionDate : shamsiDate
                );
                setValue(
                  "time_" + item.id,
                  transaction.completionTime ? transaction.completionTime : time
                );
                setValue("price_" + item.id, String(transaction.price));
                setValue("itemTransaction_" + item.id, transaction.id);
                setSupplierSelectedId(transaction.supplierId);
              }
            }

            //  دوباره برای حالت ادیت هم اگر نماینده بود، ست کن
            if (itemPerson.basketCreatorType === 1) {
              setValue("price_" + item.id, String(itemPerson.supplierSettlementPrice));
            }
          });
        });
      }
    }
  }

  const setDefaultDateAndTime = () => {
    const date = new Date();
    const shamsiDate = new DateObject({ calendar: persian, locale: customLocale });
    const hour = ("0" + date.getHours()).slice(-2);
    const minutes = ("0" + date.getMinutes()).slice(-2);
    const time = `${hour}:${minutes}`; // ##:## format
    return { shamsiDate, time };
  };

  const inputChangeHandler = (event, onChange, type, item, index1, item1) => {
    if (["percent_", "price_"].includes(type)) {
      if (type == "price_") {
        // calculating the price
        const priceValue = +event.target.value?.replace(",", "");
        const percentage = ((priceValue / item1.originalPrice) * 100).toFixed(0);
        if (index1 == 0) {
          item?.basketItemPersonList?.map((i) => setValue("percent_" + i.id, percentage));
        } else {
          setValue("percent_" + item1.id, percentage);
        }
      } else {
        // calculate the percentage
        const value = Number(event.target.value);
        if (value > 100 || value < 0) return;
        const percentage = value / 100;
        const price = showPrice.format(item1.originalPrice * percentage);
        if (index1 == 0) {
          item?.basketItemPersonList?.map((i) => setValue("price_" + i.id, price));
        } else {
          setValue("price_" + item1.id, price);
        }
      }
    }
    if (index1 == 0) {
      // setting for all the fields if its first item
      item?.basketItemPersonList?.map((i) =>
        setValue(
          type + i.id,
          type == "date_"
            ? event
            : type == "price_"
              ? showPrice.format(Number(event.target.value.replaceAll(",", "")))
              : event.target.value,
        ),
      );
    } else {
      type == "price_"
        ? setValue("price_" + item1.id, showPrice.format(Number(event.target.value.replaceAll(",", ""))))
        : onChange(event);
    }
  };
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
          {ordersServiceGetItem && ordersServiceGetItem.succeeded ? (
            <div>
              <Row>
                <Col xs="12" lg="6" xl="4" className=" mb-6">
                  <Controller
                    name="supplierSelectedId"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <SelectComponent
                        options={supplier?.map((item) => ({
                          value: item.id,
                          label: item.companyName,
                        }))}
                        placeholder="تامین کننده"
                        className="mt-5"
                        field={field}
                      />
                    )}
                  />
                  {errors.supplierSelectedId && <div className="mt-2 pl-4 text-danger">**لطفا تامین کننده را وارد نمایید.</div>}
                </Col>
              </Row>

              <Row>
                <Col>
                  <FormControlLabel
                    label="تاریخ پرداخت و تاریخ انجام تفریح برابر باشد. "
                    control={
                      <Checkbox
                        // sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                        checked={checked}
                        onChange={(event) => {
                          const isChecked = event.target.checked;
                          if (isChecked) {
                            ordersServiceGetItem.data.forEach((item) => {
                              item.basketItemPersonList.forEach((item1) => {
                                setValue("date_" + item1.id, item1.basketItemCheckInDate);
                              });
                            });
                          } else {
                            const { shamsiDate } = setDefaultDateAndTime();
                            ordersServiceGetItem.data.forEach((item) => {
                              item.basketItemPersonList.forEach((item1) => {
                                setValue("date_" + item1.id, shamsiDate);
                              });
                            });
                          }
                          setChecked(event.target.checked);
                        }}
                      />
                    }
                  />
                </Col>
              </Row>

              {ordersServiceGetItem &&
                ordersServiceGetItem.data &&
                ordersServiceGetItem.data.map((item, index) => {
                  inputList.push({
                    id: item.id,
                    priceIsLock: true,
                    dateIsLock: true,
                    timeIsLock: true,
                    basketItemId: item.basketItemId,
                  });
                  return (
                    <div className="pt-5 mt-5" key={index}>
                      <div
                        className="p-3  rounded  position-relative"
                        key={index}
                        style={{ border: "3px solid rgb(162, 166, 185)" }}
                      >
                        <div className="pt-3 div-scroll-box">
                          <h5 className="px-4 text-bold position-absolute bg-white" style={{ top: "-13px" }}>
                            {item.hallEventTitle ? `${item?.basketItemAmusementServiceName} - ${item.hallEventTitle}` : `${item?.basketItemAmusementServiceName} - ${item?.basketItemAmusementServiceReserveItemGroupTitle} - ${item?.basketItemAmusementServiceReserveItemTitle}`}
                          </h5>
                          {item?.basketItemPersonList &&
                            item.basketItemPersonList.map((item1, index1) => (
                              <div className="mb-5" key={item1.id}>
                                <Accordion>
                                  <Row className={`mt-2 min-width-row ${window.innerWidth > 991 && "flex-nowrap"}`} index={index1}>
                                    <Col xs="12" lg="auto" className="d-flex  align-items-center">
                                      <Accordion.Header className=" acc-btn-px-0" variant="link">
                                        <ClockHistory color="#767885" size={15} />
                                      </Accordion.Header>
                                    </Col>
                                    <Col xs="12" sm="4" lg="auto" className="mb-5 px-lg-1 mb-lg-0">
                                      <div className="floating-label-content">
                                        <input
                                          type="text"
                                          className={`floating-input form-control  width-input-medium `}
                                          placeholder=""
                                          value={item1.basketId}
                                          disabled
                                        />
                                        <label className="floating-label text-secondary">شماره سفارش</label>
                                      </div>
                                    </Col>
                                    <Col xs="12" sm="4" lg="auto" className="mb-5 px-lg-1 mb-lg-0">
                                      <div className="floating-label-content">
                                        <input
                                          type="text"
                                          className={`floating-input form-control  width-input-medium `}
                                          placeholder=""
                                          value={item1.id}
                                          disabled
                                        />
                                        <label className="floating-label text-secondary">شماره بلیط</label>
                                      </div>
                                    </Col>
                                    <Col xs="12" md="3" className="mb-5 px-lg-1 mb-lg-0" style={{ maxWidth: 280 }}>
                                      <TextField
                                        disabled
                                        fullWidth
                                        variant="outlined"
                                        label={item1.hallBlockName ? "صندلی" : "نام و نام خانوادگی"}
                                        value={item1.hallBlockName ? `جایگاه: ${item1.hallBlockName} - ردیف: ${item1.hallRowName} - صندلی: ${item1.hallSeatName}` : item1.personFullName}
                                      />
                                    </Col>
                                    <Col xs="12" sm="4" lg="auto" className="mb-5 px-lg-1 mb-lg-0">
                                      <div className="floating-label-content">
                                        <input
                                          type="text"
                                          className={`floating-input form-control `}
                                          placeholder=""
                                          value={`${showPrice.format(item1.payToWarantyAmount - item1.receiveOfWarantyAmount)}`}
                                          disabled
                                        />
                                        <label className="floating-label text-secondary">پرداخت تامین کننده</label>
                                      </div>
                                    </Col>
                                    <Col xs="12" sm="4" lg="auto" className="mb-5 px-lg-1 mb-lg-0">
                                      <div className="floating-label-content">
                                        <input
                                          type="text"
                                          className={`floating-input form-control width-input-medium`}
                                          placeholder=""
                                          value={`${showPrice.format(item1.paymentAmount)}`}
                                          disabled
                                        />
                                        <label className="floating-label text-secondary">مبلغ پرداختی</label>
                                      </div>
                                    </Col>
                                    <Col xs="12" sm="4" lg="auto" className="mb-5 px-lg-1 mb-lg-0">
                                      <div className="floating-label-content">
                                        <input
                                          type="text"
                                          className={`floating-input form-control  width-input-medium`}
                                          placeholder=""
                                          value={`${showPrice.format(item1.originalPrice)}`}
                                          disabled
                                        />
                                        <label className="floating-label text-secondary">نرخ مصوب </label>
                                      </div>
                                    </Col>
                                    <Col xs="12" sm="4" lg="auto" className="mb-5 px-lg-1 mb-lg-0">
                                      <Controller
                                        name={"percent_" + item1.id}
                                        control={control}
                                        render={({ field: { onChange, value } }) => (
                                          <HTMLInput
                                            className={`form-control form-control width-input-medium`}
                                            disabled={item1.basketCreatorType === 1}
                                            value={value || ""}
                                            onInput={(e) => {
                                              // فقط اعداد مثبت و صفر مجاز باشه
                                              e.target.value = e.target.value.replace(/[^0-9]/g, "");
                                            }}
                                            onChange={(event) => {
                                              inputChangeHandler(event, onChange, "percent_", item, index1, item1); // item1 == person
                                            }}
                                            label="درصد"
                                            placeholder="درصد"
                                          />
                                        )}
                                      />
                                    </Col>

                                    <Col xs="12" sm="4" lg="auto" className="mb-5 px-lg-1 mb-lg-0">
                                      <Controller
                                        name={"price_" + item1.id}
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { onChange, value } }) => {
                                          const isAgent = item1.basketCreatorType === 1;
                                          return (
                                            <HTMLInput
                                              className={`form-control ${errors["price_" + item1.id] ? "border border-danger" : ""}`}
                                              value={value || ""}
                                              title={
                                                isAgent
                                                  ? "این بلیط توسط نماینده ثبت شده و کمیسیون ویژه دارد؛ تغییر مبلغ امکان‌پذیر نیست."
                                                  : ""
                                              }
                                              onInput={(e) => {
                                                // فقط اعداد مثبت و صفر مجاز باشه
                                                e.target.value = e.target.value.replace(/[^0-9]/g, "");
                                              }}
                                              onChange={(event) => {
                                                if (!isAgent) {
                                                  inputChangeHandler(event, onChange, "price_", item, index1, item1);
                                                }
                                              }}
                                              disabled={isAgent}
                                              label="مبلغ"
                                              placeholder="مبلغ"
                                            />
                                          );
                                        }}
                                      />
                                    </Col>

                                    <Col
                                      xs="12"
                                      sm="4"
                                      lg="auto"
                                      className="mb-5 px-lg-1 mb-lg-0"
                                      style={{ position: "static" }}
                                    >
                                      <Controller
                                        name={"date_" + item1.id}
                                        control={control}
                                        style={{ zIndex: "999" }}
                                        render={({ field: { onChange, value } }) => (
                                          <ShamsiDatePicker
                                            value={value}
                                            onChange={(event) => {
                                              inputChangeHandler(event, onChange, "date_", item, index1);
                                            }}
                                            placeholder="تاریخ"
                                            style={{ zIndex: "999" }}
                                          />
                                        )}
                                      />
                                    </Col>
                                    <Col xs="12" sm="4" lg="auto" style={{ width: 120 }} className="mb-5 px-lg-1 mb-lg-0">
                                      <Controller
                                        name={"time_" + item1.id}
                                        rules={{ required: true }}
                                        control={control}
                                        render={({ field: { onChange, value } }) => (
                                          <div className="floating-label-content">
                                            <PatternFormat
                                              customInput={TextField}
                                              format="##:##"
                                              type="search"
                                              onKeyDown={(e) => {
                                                if (e.key === "Escape") {
                                                  e.stopPropagation()
                                                }
                                              }}
                                              name={"time_" + item1.id}
                                              value={value || ""}
                                              onChange={(event) => {
                                                inputChangeHandler(event, onChange, "time_", item, index1);
                                              }}
                                              variant="outlined"
                                              className={
                                                errors["time_" + item1.id]
                                                  ? "border border-danger floating-input form-control text-center"
                                                  : "floating-input form-control text-center"
                                              }
                                              placeholder="00:00"
                                            />
                                            <label className="floating-label text-secondary">ساعت</label>
                                          </div>
                                        )}
                                      />
                                    </Col>
                                    <Col xs="12" sm lg className="mb-5 px-lg-1 mb-lg-0 min-width-textarea">
                                      <Controller
                                        name={`description_${item1.id}`}
                                        control={control}
                                        render={({ field: { onChange, value } }) => (
                                          <div className="postion-relative">
                                            <textarea
                                              placeholder=""
                                              style={{ height: "43px" }}
                                              value={value || ""}
                                              className={`floating-input form-control`}
                                              onChange={(event) => {
                                                inputChangeHandler(event, onChange, "description_", item, index1);
                                              }}
                                              onKeyDown={(e) => {
                                                if (e.key === "Escape") {
                                                  const input = e.target;
                                                  if (input?.disabled) return
                                                  if (input) input.value = null;
                                                  const ev = new Event("input", { bubbles: true });
                                                  input.dispatchEvent(ev);
                                                  e.stopPropagation()
                                                }
                                              }}
                                            />
                                            <label className="floating-label text-secondary" style={{ right: 18 }}>توضیحات</label>
                                            <IconButton
                                              type="button"
                                              style={{
                                                left: 25
                                              }}
                                              className="position-absolute top-50 translate-middle w-auto"
                                              onClick={(e) => {
                                                const input = e.currentTarget.closest(".postion-relative").querySelector("textarea");
                                                if (input?.disabled || input?.readOnly) return
                                                if (input) input.value = null;
                                                const ev = new Event("input", { bubbles: true });
                                                input.dispatchEvent(ev);
                                              }}
                                              size="small"
                                            >
                                              <CloseIcon fontSize="small" />
                                            </IconButton>
                                          </div>
                                        )}
                                      />
                                    </Col>
                                    <Controller
                                      name={`itemTransaction_${item1.id}`}
                                      control={control}
                                      render={({ field: { onChange, value } }) => (
                                        <input
                                          type="hidden"
                                          value={value || ""}
                                          name={`itemTransaction_${item1.id}`}
                                          onChange={onChange}
                                        />
                                      )}
                                    />
                                  </Row>
                                  <Accordion.Body className="px-0">
                                    {/* typeS: "پرداخت_به_گارانتی_کننده" */}
                                    <Card.Body className="px-0 pt-0">
                                      {window.innerWidth < 992 ? (
                                        <HistoryOfTransactionsMobile
                                          item={item1}
                                          itemtransactions={item1.transactions}
                                        />
                                      ) : (
                                        <HistoryOfItemForDesktop
                                          item={item1}
                                          itemtransactions={item1.transactions}
                                          typeOfModalWaranty={typeOfModalWaranty}
                                        />
                                      )}
                                    </Card.Body>
                                  </Accordion.Body>
                                </Accordion>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          ) : (
            <p className="text-center text-large">{ordersServiceGetItem && ordersServiceGetItem.message}</p>
          )}
        </Modal.Body>
        <Modal.Footer className="px-2 mx-0 ">
          {ordersServiceGetItem && ordersServiceGetItem.succeeded && (
            <div>
              {/* <Button
                variant="success"
                type="submit"
                disabled={isSubmitting}
                onClick={() => {
                  setIsDeleteButton(false);
                }}
                className="btn btn-success ml-3"
              >
                {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                <SaveIcon className="mr-1" />
                ثبت
              </Button> */}
              <Button
                variant="success"
                className="btn btn-success ml-3"
                type="submit"
                onClick={() => {
                  setsubmitAndExit(true);
                  setIsDeleteButton(false);
                }}
                disabled={isSubmitting}
              >
                {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                <LogoutIcon className="mr-1 " />
                ثبت و خروج
              </Button>
              {typeOfModalWaranty?.includes("edit") && (
                <Button
                  variant="danger"
                  type="submit"
                  disabled={isSubmitting}
                  className="btn btn-success ml-3"
                  onClick={() => {
                    setIsDeleteButton(true);
                  }}
                >
                  {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                  <Delete className="mr-1" />
                  حذف
                </Button>
              )}
            </div>
          )}
          <Button variant="danger" onClick={handleClose}>
            <CloseIcon className="mr-1" />
            بستن
          </Button>
        </Modal.Footer>
      </form>
    </div>
  );
}

export default ModalGaranti;
